export interface IGroup {
    id?: number;
    name: string;
    slug: string;
    created_at?: Date;
    updated_at?: Date;
    company?: any;
    members?: any[];
    tableau_id?: string;
}

export interface IGroupList {
  count: number;
  next: string;
  previous: string;
  results: Array<IGroup>;
}

export class Group implements IGroup {
    name = '';
    slug = '';

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
